import script from "./MetricCardSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricCardSection.vue?vue&type=script&setup=true&lang=js"

import "./MetricCardSection.vue?vue&type=style&index=0&id=48aef7ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48aef7ea"]])

export default __exports__